import { Form, Offcanvas } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { StdioNull } from "node:child_process";

interface AddUsIndiaEnergyStorageProps {
    show: boolean;
    handleClose: () => void;
    data?: any;
}

type FormData = {
    title: string;
}

const AddUsIndiaEnergyStorage = ({ show, handleClose, data }: AddUsIndiaEnergyStorageProps) => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<FormData>();
    const [isLoading, setLoading] = useState(false);
    const [logo, setLogo] = useState<File | null>(null);
    const [images, setImages] = useState<any[]>([
        {}
    ]);
    const [missionData, setMissionData] = useState<any[]>([
        { title: '', description: '', image: null }
    ]);
    const [workingGroups, setWorkingGroups] = useState<any[]>([
        { image: null, title: '', description: '' }
    ]);
    const [coChairs, setCoChairs] = useState<any[]>([
        { image: null, title: '', designation: '' }
    ]);
    const [steeringCommittee, setSteeringCommittee] = useState<any[]>([
        { image: null, title: '', designation: '' }
    ]);
    const [coordinationTeam, setCoordinationTeam] = useState<any[]>([
        { image: null, title: '', designation: '' }
    ]);
    const [secretariat, setSecretariat] = useState<any[]>([
        { image: null, title: '', designation: '' }
    ]);
    const [documents, setDocuments] = useState<any[]>([
        { file: null, image: '' }
    ]);
    const [estfMembers, setEstfMembers] = useState<any[]>([
        {}
    ]);

    useEffect(() => {
        if (data) {
            reset({
                title: data.title || '',
            });
            setImages(data.images && data.images.length > 0 ? data.images : [{}]);
            setMissionData(data.missionContent && data.missionContent.length > 0 ? data.missionContent : [{ title: '', description: '', image: null }]);
            setWorkingGroups(data.workingGroup && data.workingGroup.length > 0 ? data.workingGroup : [{ image: null, title: '', description: '' }]);
            setCoChairs(data.coChair && data.coChair.length > 0 ? data.coChair : [{ image: null, title: '', designation: '' }]);
            setSteeringCommittee(data.steeringCommittee && data.steeringCommittee.length > 0 ? data.steeringCommittee : [{ image: null, title: '', designation: '' }]);
            setCoordinationTeam(data.coordinationTeam && data.coordinationTeam.length > 0 ? data.coordinationTeam : [{ image: null, title: '', designation: '' }]);
            setSecretariat(data.secretariat && data.secretariat.length > 0 ? data.secretariat : [{ image: null, title: '', designation: '' }]);
            setDocuments(data.documents && data.documents.length > 0 ? data.documents : [{ file: null, image: null }]);
            setEstfMembers(data.members && data.members.length > 0 ? data.members : [{ title: '' }]);
        }
    }, [data])

    const onSubmit = (request: FormData) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("title", request.title);
        if (logo) {
            formData.append("logo", logo);
        }
        if (images.length > 0 && images.every(img => img && Object.keys(img).length !== 0 && img !== "")) {
            formData.append("images", JSON.stringify(images));
        }
        if (missionData.length > 0 && missionData.every(mission => mission.title.trim() !== '' || mission.description.trim() !== '' || (mission.image && Object.keys(mission.image).length !== 0))) {
            formData.append("missionContent", JSON.stringify(missionData));
        }
        if (workingGroups.length > 0 && workingGroups.every(group => group.title.trim() !== '' || group.description.trim() !== '' || (group.image && Object.keys(group.image).length !== 0))) {
            formData.append("workingGroup", JSON.stringify(workingGroups));
        }
        if (coChairs.length > 0 && coChairs.every(coChair => coChair.title.trim() !== '' || coChair.designation.trim() !== '' || (coChair.image && Object.keys(coChair.image).length !== 0))) {
            formData.append("coChair", JSON.stringify(coChairs));
        }
        if (steeringCommittee.length > 0 && steeringCommittee.every(member => member.title.trim() !== '' || member.designation.trim() !== '' || (member.image && Object.keys(member.image).length !== 0))) {
            formData.append("steeringCommittee", JSON.stringify(steeringCommittee));
        }
        if (coordinationTeam.length > 0 && coordinationTeam.every(member => member.title.trim() !== '' || member.designation.trim() !== '' || (member.image && Object.keys(member.image).length !== 0))) {
            formData.append("coordinationTeam", JSON.stringify(coordinationTeam));
        }
        if (secretariat.length > 0 && secretariat.every(member => member.title.trim() !== '' || member.designation.trim() !== '' || (member.image && Object.keys(member.image).length !== 0))) {
            formData.append("secretariat", JSON.stringify(secretariat));
        }
        if (documents.length > 0 && documents.every(doc => (doc.file && Object.keys(doc.file).length !== 0) || doc.link.trim() !== '')) {
            formData.append("documents", JSON.stringify(documents));
        }
        if (estfMembers.length > 0 && estfMembers.every(member => member.trim() !== '')) {
            formData.append('members', JSON.stringify(estfMembers));
        }
        WebService.fileUploadAPI({
            action: `us-india-energy-storage/addContent`,
            body: formData
        })
            .then((res: any) => {
                toast.success(res.message)
                setLoading(false);
                handleClose();
            })
            .catch((err: any) => {
                setLoading(false);
                toast.error(err.response?.data?.message || "An error occurred");
            })
    }

    const uploadFile = (file: File, index: number, type: string) => {
        const formData = new FormData();
        formData.append("file", file);
        WebService.fileUploadAPI({
            action: `upload`,
            body: formData
        })
            .then((res: any) => {
                if (res.data) {
                    if (type === "MISSION") {
                        missionData[index].image = res.data?.url;
                        setMissionData([...missionData]);
                    } else if (type === "WORKING_GROUP") {
                        workingGroups[index].image = res.data?.url;
                        setWorkingGroups([...workingGroups]);
                    } else if (type === 'CO_CHAIR') {
                        coChairs[index].image = res.data?.url;
                        setCoChairs([...coChairs]);
                    } else if (type === "STEERING_COMMITTEE") {
                        steeringCommittee[index].image = res.data?.url;
                        setSteeringCommittee([...steeringCommittee]);
                    } else if (type === "COORDINATION_TEAM") {
                        coordinationTeam[index].image = res.data?.url;
                        setCoordinationTeam([...coordinationTeam]);
                    } else if (type === "SECRETARIAT") {
                        secretariat[index].image = res.data?.url;
                        setSecretariat([...secretariat]);
                    } else if (type === "DOCUMENT") {
                        documents[index].image = res.data?.url;
                        setDocuments([...documents]);
                    } else if (type === "DOCUMENT_FILE") {
                        documents[index].file = res.data?.url;
                        setDocuments([...documents]);
                    } else {
                        images[index] = res.data?.url;
                        setImages([...images]);
                    }
                }
            })
            .catch((err: any) => {
                toast.error(err.response?.data?.message || "An error occurred");
            });
    }


    return (
        <>
            <Offcanvas show={show} onHide={() => {
                handleClose();
            }}
                placement="end"
                className="offcanvas-custom">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{data ? 'Edit' : 'Add'}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-2" controlId="logo">
                            <Form.Label className="label">Logo</Form.Label>
                            <Form.Control
                                type="file"
                                accept="image/*"
                                className="custom-image-upload"
                                onChange={(e) => {
                                    const input = e.target as HTMLInputElement;
                                    const file = input.files && input.files[0];
                                    if (file) {
                                        setLogo(file);
                                    }
                                }}
                            />
                        </Form.Group>
                        {(logo || data?.logo) && (
                            <div className="mb-2 event-image">
                                <img
                                    src={
                                        logo
                                            ? URL.createObjectURL(logo)
                                            : data?.logo
                                    }
                                    alt="Event"
                                    style={{ maxWidth: "100%", maxHeight: 200, objectFit: "contain" }}
                                />
                            </div>
                        )}
                        <Form.Group className="mb-2" controlId="title">
                            <Form.Label className="label">Title</Form.Label>
                            <Form.Control type="text" placeholder="Enter title"
                                {...register("title", { required: 'Title is required' })} />
                            {errors.title && <div className="error-message">{errors.title.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="images">
                            <Form.Label className="label">Images</Form.Label>
                            {
                                images.map((image, index) => (
                                    <>
                                        <div className="d-flex mt-2">
                                            <Form.Control
                                                type="file"
                                                accept="image/*"
                                                className="custom-image-upload"
                                                onChange={(e) => {
                                                    const input = e.target as HTMLInputElement;
                                                    const file = input.files && input.files[0];
                                                    if (file) {
                                                        uploadFile(file, index, 'CRAUSAL');
                                                    }
                                                }}
                                            />
                                            <div className="d-flex mt-2">
                                                <PlusSquareFill
                                                    onClick={() => {
                                                        setImages([...images, {}]);
                                                    }}
                                                    className="ms-2 me-2 cursor-pointer"
                                                />
                                                {images.length > 1 && <DashSquareFill
                                                    onClick={() => {
                                                        const newImages = images.filter((_, i) => i !== index);
                                                        setImages(newImages);
                                                    }}
                                                    className="cursor-pointer"
                                                />}
                                            </div>
                                        </div>
                                        {(image && Object.keys(image).length !== 0) && (
                                            <div className="mt-2 event-image">
                                                <img
                                                    src={
                                                        image
                                                    }
                                                    style={{ maxWidth: "100%", maxHeight: 200, objectFit: "contain" }}
                                                />
                                            </div>
                                        )}
                                    </>
                                ))
                            }
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="eventDescription">
                            <Form.Label className="label">Mission Content</Form.Label>
                            {
                                missionData.map((mission, index) => (
                                    <div
                                        key={index}
                                        draggable
                                        onDragStart={e => {
                                            e.dataTransfer.setData("MissionIndex", index.toString());
                                        }}
                                        onDragOver={e => e.preventDefault()}
                                        onDrop={e => {
                                            const fromIndex = Number(e.dataTransfer.getData("MissionIndex"));
                                            if (fromIndex === index) return;
                                            const newMissionData = [...missionData];
                                            const [moved] = newMissionData.splice(fromIndex, 1);
                                            newMissionData.splice(index, 0, moved);
                                            setMissionData(newMissionData);
                                        }}
                                        style={{ cursor: "move" }}
                                    >
                                        <div className="d-flex align-items-start">
                                            <span
                                                style={{
                                                    cursor: "grab",
                                                    marginRight: 8,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: 20,
                                                    color: "#888",
                                                    marginTop: 10
                                                }}
                                                title="Drag to reorder"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                                    <circle cx="5" cy="6" r="1.5" />
                                                    <circle cx="5" cy="10" r="1.5" />
                                                    <circle cx="5" cy="14" r="1.5" />
                                                    <circle cx="11" cy="6" r="1.5" />
                                                    <circle cx="11" cy="10" r="1.5" />
                                                    <circle cx="11" cy="14" r="1.5" />
                                                </svg>
                                            </span>
                                            <div style={{ flex: 1 }} className="highlight-item">
                                                <Form.Control
                                                    type="file"
                                                    accept="image/*"
                                                    className="custom-image-upload"
                                                    onChange={(e) => {
                                                        const input = e.target as HTMLInputElement;
                                                        const file = input.files && input.files[0];
                                                        if (file) {
                                                            uploadFile(file, index, 'MISSION');
                                                        }
                                                    }}
                                                />
                                                {missionData[index] && (
                                                    <img
                                                        src={
                                                            missionData[index].image
                                                                ? missionData[index].image
                                                                : data?.missionData?.[index]?.imageUrl || ""
                                                        }
                                                        style={{ maxWidth: "100%", maxHeight: 100, objectFit: "contain", borderRadius: 8, marginTop: 10, marginBottom: 10 }}
                                                    />
                                                )}
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Name`}
                                                        value={missionData[index].title}
                                                        onChange={(e) => {
                                                            const newMissionData = [...missionData];
                                                            newMissionData[index].title = e.target.value;
                                                            setMissionData(newMissionData);
                                                        }}
                                                    />
                                                    <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setMissionData([...missionData, { title: '', description: '', image: null }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {missionData.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newMissionData = missionData.filter((_, i) => i !== index);
                                                                setMissionData(newMissionData);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div>
                                                </div>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={`Description`}
                                                    value={missionData[index].description}
                                                    onChange={(e) => {
                                                        const newMissionData = [...missionData];
                                                        newMissionData[index].description = e.target.value;
                                                        setMissionData(newMissionData);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }

                        </Form.Group>

                        {/* Working Groups */}
                        <Form.Group className="mb-2" controlId="eventDescription">
                            <Form.Label className="label">Working Group</Form.Label>
                            {
                                workingGroups.map((group, index) => (
                                    <div
                                        key={index}
                                        draggable
                                        onDragStart={e => {
                                            e.dataTransfer.setData("GroupIndex", index.toString());
                                        }}
                                        onDragOver={e => e.preventDefault()}
                                        onDrop={e => {
                                            const fromIndex = Number(e.dataTransfer.getData("GroupIndex"));
                                            if (fromIndex === index) return;
                                            const newWorkingGroups = [...workingGroups];
                                            const [moved] = newWorkingGroups.splice(fromIndex, 1);
                                            newWorkingGroups.splice(index, 0, moved);
                                            setWorkingGroups(newWorkingGroups);
                                        }}
                                        style={{ cursor: "move" }}
                                    >
                                        <div className="d-flex align-items-start">
                                            <span
                                                style={{
                                                    cursor: "grab",
                                                    marginRight: 8,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: 20,
                                                    color: "#888",
                                                    marginTop: 10
                                                }}
                                                title="Drag to reorder"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                                    <circle cx="5" cy="6" r="1.5" />
                                                    <circle cx="5" cy="10" r="1.5" />
                                                    <circle cx="5" cy="14" r="1.5" />
                                                    <circle cx="11" cy="6" r="1.5" />
                                                    <circle cx="11" cy="10" r="1.5" />
                                                    <circle cx="11" cy="14" r="1.5" />
                                                </svg>
                                            </span>
                                            <div style={{ flex: 1 }} className="highlight-item">
                                                <Form.Control
                                                    type="file"
                                                    accept="image/*"
                                                    className="custom-image-upload"
                                                    onChange={(e) => {
                                                        const input = e.target as HTMLInputElement;
                                                        const file = input.files && input.files[0];
                                                        if (file) {
                                                            uploadFile(file, index, 'WORKING_GROUP');
                                                        }
                                                    }}
                                                />
                                                {workingGroups[index] && (
                                                    <img
                                                        src={
                                                            workingGroups[index].image
                                                                ? workingGroups[index].image
                                                                : data?.workingGroups?.[index]?.imageUrl || ""
                                                        }
                                                        style={{ maxWidth: "100%", maxHeight: 100, objectFit: "contain", borderRadius: 8, marginTop: 10, marginBottom: 10 }}
                                                    />
                                                )}
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Name`}
                                                        value={workingGroups[index].title}
                                                        onChange={(e) => {
                                                            const newWorkingGroups = [...workingGroups];
                                                            newWorkingGroups[index].title = e.target.value;
                                                            setWorkingGroups(newWorkingGroups);
                                                        }}
                                                    />
                                                    <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setWorkingGroups([...workingGroups, { image: null, title: '', description: '' }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {workingGroups.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newWorkingGroups = workingGroups.filter((_, i) => i !== index);
                                                                setWorkingGroups(newWorkingGroups);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div>
                                                </div>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={`Description`}
                                                    value={workingGroups[index].description}
                                                    onChange={(e) => {
                                                        const newWorkingGroups = [...workingGroups];
                                                        newWorkingGroups[index].description = e.target.value;
                                                        setWorkingGroups(newWorkingGroups);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Form.Group>

                        {/* Co-chairs */}
                        <Form.Group className="mb-2" controlId="eventDescription">
                            <Form.Label className="label">Co-chair</Form.Label>
                            {
                                coChairs.map((coChair, index) => (
                                    <div
                                        key={index}
                                        draggable
                                        onDragStart={e => {
                                            e.dataTransfer.setData("coChairIndex", index.toString());
                                        }}
                                        onDragOver={e => e.preventDefault()}
                                        onDrop={e => {
                                            const fromIndex = Number(e.dataTransfer.getData("coChairIndex"));
                                            if (fromIndex === index) return;
                                            const newCoChairs = [...coChairs];
                                            const [moved] = newCoChairs.splice(fromIndex, 1);
                                            newCoChairs.splice(index, 0, moved);
                                            setCoChairs(newCoChairs);
                                        }}
                                        style={{ cursor: "move" }}
                                    >
                                        <div className="d-flex align-items-start">
                                            <span
                                                style={{
                                                    cursor: "grab",
                                                    marginRight: 8,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: 20,
                                                    color: "#888",
                                                    marginTop: 10
                                                }}
                                                title="Drag to reorder"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                                    <circle cx="5" cy="6" r="1.5" />
                                                    <circle cx="5" cy="10" r="1.5" />
                                                    <circle cx="5" cy="14" r="1.5" />
                                                    <circle cx="11" cy="6" r="1.5" />
                                                    <circle cx="11" cy="10" r="1.5" />
                                                    <circle cx="11" cy="14" r="1.5" />
                                                </svg>
                                            </span>
                                            <div style={{ flex: 1 }} className="highlight-item">
                                                <Form.Control
                                                    type="file"
                                                    accept="image/*"
                                                    className="custom-image-upload"
                                                    onChange={(e) => {
                                                        const input = e.target as HTMLInputElement;
                                                        const file = input.files && input.files[0];
                                                        if (file) {
                                                            uploadFile(file, index, 'CO_CHAIR');
                                                        }
                                                    }}
                                                />
                                                {coChairs[index] && (
                                                    <img
                                                        src={
                                                            coChairs[index].image
                                                                ? coChairs[index].image
                                                                : data?.coChairs?.[index]?.imageUrl || ""
                                                        }
                                                        style={{ maxWidth: "100%", maxHeight: 100, objectFit: "contain", borderRadius: 8, marginTop: 10, marginBottom: 10 }}
                                                    />
                                                )}
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Name`}
                                                        value={coChairs[index].title}
                                                        onChange={(e) => {
                                                            const newCoChairs = [...coChairs];
                                                            newCoChairs[index].title = e.target.value;
                                                            setCoChairs(newCoChairs);
                                                        }}
                                                    />
                                                    <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setWorkingGroups([...workingGroups, { image: null, title: '' }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {workingGroups.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newWorkingGroups = workingGroups.filter((_, i) => i !== index);
                                                                setWorkingGroups(newWorkingGroups);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div>
                                                </div>
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Designation`}
                                                        value={coChairs[index].designation}
                                                        onChange={(e) => {
                                                            const newCoChairs = [...coChairs];
                                                            newCoChairs[index].designation = e.target.value;
                                                            setCoChairs(newCoChairs);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Form.Group>

                        {/* Steering Committee */}
                        <Form.Group className="mb-2" controlId="Steering-Committee">
                            <Form.Label className="label">Steering Committee</Form.Label>
                            {
                                steeringCommittee.map((member, index) => (
                                    <div
                                        key={index}
                                        draggable
                                        onDragStart={e => {
                                            e.dataTransfer.setData("memberIndex", index.toString());
                                        }}
                                        onDragOver={e => e.preventDefault()}
                                        onDrop={e => {
                                            const fromIndex = Number(e.dataTransfer.getData("memberIndex"));
                                            if (fromIndex === index) return;
                                            const newSteeringCommittee = [...steeringCommittee];
                                            const [moved] = newSteeringCommittee.splice(fromIndex, 1);
                                            newSteeringCommittee.splice(index, 0, moved);
                                            setSteeringCommittee(newSteeringCommittee);
                                        }}
                                        style={{ cursor: "move" }}
                                    >
                                        <div className="d-flex align-items-start">
                                            <span
                                                style={{
                                                    cursor: "grab",
                                                    marginRight: 8,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: 20,
                                                    color: "#888",
                                                    marginTop: 10
                                                }}
                                                title="Drag to reorder"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                                    <circle cx="5" cy="6" r="1.5" />
                                                    <circle cx="5" cy="10" r="1.5" />
                                                    <circle cx="5" cy="14" r="1.5" />
                                                    <circle cx="11" cy="6" r="1.5" />
                                                    <circle cx="11" cy="10" r="1.5" />
                                                    <circle cx="11" cy="14" r="1.5" />
                                                </svg>
                                            </span>
                                            <div style={{ flex: 1 }} className="highlight-item">
                                                <Form.Control
                                                    type="file"
                                                    accept="image/*"
                                                    className="custom-image-upload"
                                                    onChange={(e) => {
                                                        const input = e.target as HTMLInputElement;
                                                        const file = input.files && input.files[0];
                                                        if (file) {
                                                            uploadFile(file, index, 'STEERING_COMMITTEE');
                                                        }
                                                    }}
                                                />
                                                {steeringCommittee[index] && (
                                                    <img
                                                        src={
                                                            steeringCommittee[index].image
                                                                ? steeringCommittee[index].image
                                                                : data?.steeringCommittee?.[index]?.imageUrl || ""
                                                        }
                                                        style={{ maxWidth: "100%", maxHeight: 100, objectFit: "contain", borderRadius: 8, marginTop: 10, marginBottom: 10 }}
                                                    />
                                                )}
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Name`}
                                                        value={steeringCommittee[index].title}
                                                        onChange={(e) => {
                                                            const newSteeringCommittee = [...steeringCommittee];
                                                            newSteeringCommittee[index].title = e.target.value;
                                                            setSteeringCommittee(newSteeringCommittee);
                                                        }}
                                                    />
                                                    <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setSteeringCommittee([...steeringCommittee, { image: null, title: '' }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {steeringCommittee.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newSteeringCommittee = steeringCommittee.filter((_, i) => i !== index);
                                                                setSteeringCommittee(newSteeringCommittee);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div>
                                                </div>
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Designation`}
                                                        value={steeringCommittee[index].designation}
                                                        onChange={(e) => {
                                                            const newSteeringCommittee = [...steeringCommittee];
                                                            newSteeringCommittee[index].designation = e.target.value;
                                                            setSteeringCommittee(newSteeringCommittee);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Form.Group>

                        {/* Coordination Team  */}
                        <Form.Group className="mb-2" controlId="Coordination-Team">
                            <Form.Label className="label">Coordination Team</Form.Label>
                            {
                                coordinationTeam.map((member, index) => (
                                    <div
                                        key={index}
                                        draggable
                                        onDragStart={e => {
                                            e.dataTransfer.setData("coordinationIndex", index.toString());
                                        }}
                                        onDragOver={e => e.preventDefault()}
                                        onDrop={e => {
                                            const fromIndex = Number(e.dataTransfer.getData("coordinationIndex"));
                                            if (fromIndex === index) return;
                                            const newCoordinationTeam = [...coordinationTeam];
                                            const [moved] = newCoordinationTeam.splice(fromIndex, 1);
                                            newCoordinationTeam.splice(index, 0, moved);
                                            setCoordinationTeam(newCoordinationTeam);
                                        }}
                                        style={{ cursor: "move" }}
                                    >
                                        <div className="d-flex align-items-start">
                                            <span
                                                style={{
                                                    cursor: "grab",
                                                    marginRight: 8,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: 20,
                                                    color: "#888",
                                                    marginTop: 10
                                                }}
                                                title="Drag to reorder"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                                    <circle cx="5" cy="6" r="1.5" />
                                                    <circle cx="5" cy="10" r="1.5" />
                                                    <circle cx="5" cy="14" r="1.5" />
                                                    <circle cx="11" cy="6" r="1.5" />
                                                    <circle cx="11" cy="10" r="1.5" />
                                                    <circle cx="11" cy="14" r="1.5" />
                                                </svg>
                                            </span>
                                            <div style={{ flex: 1 }} className="highlight-item">
                                                <Form.Control
                                                    type="file"
                                                    accept="image/*"
                                                    className="custom-image-upload"
                                                    onChange={(e) => {
                                                        const input = e.target as HTMLInputElement;
                                                        const file = input.files && input.files[0];
                                                        if (file) {
                                                            uploadFile(file, index, 'COORDINATION_TEAM');
                                                        }
                                                    }}
                                                />
                                                {coordinationTeam[index] && (
                                                    <img
                                                        src={
                                                            coordinationTeam[index].image
                                                                ? coordinationTeam[index].image
                                                                : data?.coordinationTeam?.[index]?.imageUrl || ""
                                                        }
                                                        style={{ maxWidth: "100%", maxHeight: 100, objectFit: "contain", borderRadius: 8, marginTop: 10, marginBottom: 10 }}
                                                    />
                                                )}
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Name`}
                                                        value={coordinationTeam[index].title}
                                                        onChange={(e) => {
                                                            const newCoordinationTeam = [...coordinationTeam];
                                                            newCoordinationTeam[index].title = e.target.value;
                                                            setCoordinationTeam(newCoordinationTeam);
                                                        }}
                                                    />
                                                    <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setCoordinationTeam([...coordinationTeam, { image: null, title: '' }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {coordinationTeam.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newCoordinationTeam = coordinationTeam.filter((_, i) => i !== index);
                                                                setCoordinationTeam(newCoordinationTeam);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div>
                                                </div>
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Designation`}
                                                        value={coordinationTeam[index].designation}
                                                        onChange={(e) => {
                                                            const newCoordinationTeam = [...coordinationTeam];
                                                            newCoordinationTeam[index].designation = e.target.value;
                                                            setCoordinationTeam(newCoordinationTeam);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Form.Group>

                        {/* Secretariat */}
                        <Form.Group className="mb-2" controlId="Secretariat">
                            <Form.Label className="label">Secretariat</Form.Label>
                            {
                                secretariat.map((member, index) => (
                                    <div
                                        key={index}
                                        draggable
                                        onDragStart={e => {
                                            e.dataTransfer.setData("secretariatIndex", index.toString());
                                        }}
                                        onDragOver={e => e.preventDefault()}
                                        onDrop={e => {
                                            const fromIndex = Number(e.dataTransfer.getData("secretariatIndex"));
                                            if (fromIndex === index) return;
                                            const newSecretariat = [...secretariat];
                                            const [moved] = newSecretariat.splice(fromIndex, 1);
                                            newSecretariat.splice(index, 0, moved);
                                            setSecretariat(newSecretariat);
                                        }}
                                        style={{ cursor: "move" }}
                                    >
                                        <div className="d-flex align-items-start">
                                            <span
                                                style={{
                                                    cursor: "grab",
                                                    marginRight: 8,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: 20,
                                                    color: "#888",
                                                    marginTop: 10
                                                }}
                                                title="Drag to reorder"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                                    <circle cx="5" cy="6" r="1.5" />
                                                    <circle cx="5" cy="10" r="1.5" />
                                                    <circle cx="5" cy="14" r="1.5" />
                                                    <circle cx="11" cy="6" r="1.5" />
                                                    <circle cx="11" cy="10" r="1.5" />
                                                    <circle cx="11" cy="14" r="1.5" />
                                                </svg>
                                            </span>
                                            <div style={{ flex: 1 }} className="highlight-item">
                                                <Form.Control
                                                    type="file"
                                                    accept="image/*"
                                                    className="custom-image-upload"
                                                    onChange={(e) => {
                                                        const input = e.target as HTMLInputElement;
                                                        const file = input.files && input.files[0];
                                                        if (file) {
                                                            uploadFile(file, index, 'SECRETARIAT');
                                                        }
                                                    }}
                                                />
                                                {secretariat[index] && (
                                                    <img
                                                        src={
                                                            secretariat[index].image
                                                                ? secretariat[index].image
                                                                : data?.secretariat?.[index]?.imageUrl || ""
                                                        }
                                                        style={{ maxWidth: "100%", maxHeight: 100, objectFit: "contain", borderRadius: 8, marginTop: 10, marginBottom: 10 }}
                                                    />
                                                )}
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Name`}
                                                        value={secretariat[index].title}
                                                        onChange={(e) => {
                                                            const newSecretariat = [...secretariat];
                                                            newSecretariat[index].title = e.target.value;
                                                            setSecretariat(newSecretariat);
                                                        }}
                                                    />
                                                    <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setSecretariat([...secretariat, { image: null, title: '' }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {secretariat.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newSecretariat = secretariat.filter((_, i) => i !== index);
                                                                setSecretariat(newSecretariat);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div>
                                                </div>
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Designation`}
                                                        value={secretariat[index].designation}
                                                        onChange={(e) => {
                                                            const newSecretariat = [...secretariat];
                                                            newSecretariat[index].designation = e.target.value;
                                                            setSecretariat(newSecretariat);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Form.Group>

                        {/* Documents */}
                        <Form.Group className="mb-2" controlId="Secretariat">
                            <Form.Label className="label">Documents</Form.Label>
                            {
                                documents.map((document, index) => (
                                    <div
                                        key={index}
                                        draggable
                                        onDragStart={e => {
                                            e.dataTransfer.setData("documentIndex", index.toString());
                                        }}
                                        onDragOver={e => e.preventDefault()}
                                        onDrop={e => {
                                            const fromIndex = Number(e.dataTransfer.getData("documentIndex"));
                                            if (fromIndex === index) return;
                                            const newDocuments = [...documents];
                                            const [moved] = newDocuments.splice(fromIndex, 1);
                                            newDocuments.splice(index, 0, moved);
                                            setDocuments(newDocuments);
                                        }}
                                        style={{ cursor: "move" }}
                                    >
                                        <div className="d-flex align-items-start">
                                            <span
                                                style={{
                                                    cursor: "grab",
                                                    marginRight: 8,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontSize: 20,
                                                    color: "#888",
                                                    marginTop: 10
                                                }}
                                                title="Drag to reorder"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                                    <circle cx="5" cy="6" r="1.5" />
                                                    <circle cx="5" cy="10" r="1.5" />
                                                    <circle cx="5" cy="14" r="1.5" />
                                                    <circle cx="11" cy="6" r="1.5" />
                                                    <circle cx="11" cy="10" r="1.5" />
                                                    <circle cx="11" cy="14" r="1.5" />
                                                </svg>
                                            </span>
                                            <div style={{ flex: 1 }} className="highlight-item">
                                                <Form.Label className="label">Image</Form.Label>
                                                <div className="d-flex">
                                                    <Form.Control
                                                        type="file"
                                                        accept="image/*"
                                                        className="custom-image-upload"
                                                        onChange={(e) => {
                                                            const input = e.target as HTMLInputElement;
                                                            const file = input.files && input.files[0];
                                                            if (file) {
                                                                uploadFile(file, index, 'DOCUMENT');
                                                            }
                                                        }}
                                                    />



                                                    <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setDocuments([...documents, { file: null, image: null }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {documents.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newDocuments = documents.filter((_, i) => i !== index);
                                                                setDocuments(newDocuments);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div>
                                                </div>
                                                {documents[index] && (
                                                    <img
                                                        src={
                                                            documents[index].image
                                                                ? documents[index].image
                                                                : data?.documents?.[index]?.imageUrl || ""
                                                        }
                                                        style={{ maxWidth: "100%", maxHeight: 100, objectFit: "contain", borderRadius: 8, marginTop: 10, marginBottom: 10 }}
                                                    />
                                                )}
                                                <div>
                                                    <Form.Label className="label">File</Form.Label>
                                                    <div className="">
                                                        <Form.Control
                                                            type="file"
                                                            accept=".pdf,.doc,.docx,.xls,.xlsx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                            className="custom-image-upload"
                                                            onChange={(e) => {
                                                                const input = e.target as HTMLInputElement;
                                                                const file = input.files && input.files[0];
                                                                if (file) {
                                                                    uploadFile(file, index, 'DOCUMENT_FILE');
                                                                }
                                                            }}
                                                        />
                                                        <div className="mt-2 cursor-pointer" onClick={() => {
                                                            if (documents[index]?.file && typeof documents[index].file === "string") {
                                                                window.open(documents[index].file, '_blank');
                                                            }
                                                        }}>
                                                            {documents[index]?.file && (
                                                                <span className="ms-2">
                                                                    {typeof documents[index].file === "string"
                                                                        ? documents[index].file.split('/').pop()
                                                                        : documents[index].file.name}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Form.Group>


                        <Form.Group className="mb-2" controlId="estfMembers">
                            <Form.Label className="label">ESTF Members</Form.Label>
                            {estfMembers.map((member, index) => (
                                <div key={index} className="d-flex align-items-center mb-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="Name"
                                        value={member}
                                        className="me-2"
                                        onChange={(e) => {
                                            const newEstfMembers = [...estfMembers];
                                            newEstfMembers[index] = e.target.value;
                                            setEstfMembers(newEstfMembers);
                                        }}
                                    />
                                    <PlusSquareFill
                                        onClick={() => setEstfMembers([...estfMembers, {}])}
                                        className="ms-2 me-2 cursor-pointer"
                                    />
                                    {estfMembers.length > 1 && (
                                        <DashSquareFill
                                            onClick={() => setEstfMembers(estfMembers.filter((_, i) => i !== index))}
                                            className="cursor-pointer"
                                        />
                                    )}
                                </div>
                            ))}
                        </Form.Group>
                    </Form>
                </Offcanvas.Body>
                <div className="d-flex justify-content-end p-3">
                    <CustomButton
                        isLoading={isLoading}
                        label="Save"
                        className="w-100"
                        onClick={handleSubmit(onSubmit)}
                    />
                </div>
            </Offcanvas>
        </>
    )
}

export default AddUsIndiaEnergyStorage;
